// extracted by mini-css-extract-plugin
module.exports = {"smallText":"Checkbox_smallText__1gA57"};